export const CheckCircle=()=>{
  return(
    <>
      <svg width="61" height="60" viewBox="0 0 61 60" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M40.8125 24.375L27.0547 37.5L20.1875 30.9375" stroke="white" strokeWidth="3.75" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M30.5 52.5C42.9264 52.5 53 42.4264 53 30C53 17.5736 42.9264 7.5 30.5 7.5C18.0736 7.5 8 17.5736 8 30C8 42.4264 18.0736 52.5 30.5 52.5Z" stroke="white" strokeWidth="3.75" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
    </>
  )
}